
import * as CryptoJS from "crypto-js";


const key = process.env.REACT_APP_API_SECRET;
/*
   * Encrypt a derived hd private key with a given pin and return it in Base64 form
   */
export const encryptAES = (text:string) => {
  const ciphertext = CryptoJS.AES.encrypt(text, key||"").toString();

  return ciphertext;
  };

  /**
   * Decrypt an encrypted message
   * @param encryptedBase64 encrypted data in base64 format
   * @param key The secret key
   * @return The decrypted content
   */
  export const decryptAES = (encryptedBase64:string) => {
 
    const bytes = CryptoJS.AES.decrypt(encryptedBase64, key||"");
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  };